import { createContext, useContext, useEffect, useState } from "react";
import { ADMIN, URL } from "../../lib/lib";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    
    const [auth, setAuth] = useState({isLoggedIn : false, user : null, loading: true });
    
    const checkAuth = async () => {
        try {
            
            const response = await fetch(URL + ADMIN.auth, {
                credentials: "include",
                method: "POST",
            });

            if(!response.ok) {
                setAuth({ isLoggedIn: false, user: null, loading: false });
                return; 
            }
            
            const request = await response.json();
            

            if (request.status) {
                setAuth({ isLoggedIn: true, user: null, loading: false });
            } else {
                setAuth({ isLoggedIn: false, user: null, loading: false });
            } 
        } catch (error) {
            setAuth({ isLoggedIn: false, user: null, loading: false });
        }
    }

    const logout = async () => {
        await fetch(URL + ADMIN.logout, {
            method: "POST",
            credentials: "include",
        });
        setAuth({ isLoggedIn: false, user: null, loading: false });
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ ...auth, setAuth, logout, refreshAuth: checkAuth }}>
          {auth.loading ? (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
                </div>
            </div>
            ) : (children)}

        </AuthContext.Provider>
    );
};

export const useAdminAuth = () => useContext(AuthContext);